import { GetServerSidePropsContext } from 'next';

import { deleteCookie, getCookie, setCookie } from '@/util/cookieUtil';
import { LWTDate } from '@/valueObjects/date';

// in days
const LIFE_TIME = 30;

export const ACCOUNT_NAME_KEY = 'accountName';
export const PASSWORD_KEY = 'password';

export type TAccountInfo = Readonly<{
  accountName: string;
  password: string;
}>;

export const destroyAccountInfoCookie = (context?: GetServerSidePropsContext): void =>
  [ACCOUNT_NAME_KEY, PASSWORD_KEY].forEach((key) => deleteCookie(key, context));

export const getAccountInfoCookie = (context: GetServerSidePropsContext): TAccountInfo => {
  return {
    accountName: getCookie(ACCOUNT_NAME_KEY, context) ?? '',
    password: getCookie(PASSWORD_KEY, context) ?? '',
  };
};

export const setAccountInfoCookie = (userName: string, password: string) => {
  const expires = new LWTDate();
  expires.setDate(expires.getDate() + LIFE_TIME);
  setCookie(ACCOUNT_NAME_KEY, userName, expires);
  setCookie(PASSWORD_KEY, password, expires);
};
